import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import AppContext from '@services/Context';
import { TypesValidation } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Form, Icon } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React from 'react';

import IExecutionComponent from '../interfaces/IExecutionComponent';


export interface IDateExecutionProps extends IExecutionComponent {
  description: string;
  repeat: boolean;
  dateMin: number;
  dateMax: number;
  UseTodayMin: boolean;
  UseTodayMax: boolean;
  minRepeat: number;
  maxRepeat: number;
  required: boolean;
  hour: boolean;
}

interface IDateExecutionState {
  dateComponent: any;
  valid: boolean[];
}
export default class DateExecutionComponent extends React.Component<IDateExecutionProps, IDateExecutionState> {
  constructor(props: IDateExecutionProps) {
    super(props);
    this.disabledDate = this.disabledDate.bind(this);
    this.state = {
      dateComponent: [{ value: "" }],
      valid: [true],
    }
  }

  componentDidMount = async () => {
    await this.initialFields();
    const { defaultValue } = this.props;
    if (defaultValue && defaultValue.length > 0) {
      this.setState({dateComponent: defaultValue.map(v => ({value: v}))})
    }
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    if (JSON.stringify(prevState.dateComponent) !== JSON.stringify(this.state.dateComponent)) {
      let valid = this.validationFunction(this.state.dateComponent)
      this.setState({ valid: valid })
      this.props.onChange(
        {
          id: this.props.id,
          value: this.state.dateComponent.map((e: any) => e.value),
          validation: !valid.includes(false),
        }
      )
    }
  }

  initialFields = async () => {
    let i = 0;
    let dateInitial = []
    if (this.props.repeat) {
      while (i < this.props.minRepeat) {
        dateInitial.push({ value: "" })
        i++;
      }
      this.setState({ dateComponent: dateInitial.length > 0 ? dateInitial : [{ value: "" }] })
    }
  }

  //#region  START HANDLES 
  handleDateChange = (idx: any) => async (date: any) => {
    const newInputDate = this.state.dateComponent.map((items: any, sidx: number) => {
      const newDate = date !== null ? date.toDate().getTime() : ''
      if (idx !== sidx) return items;
      return { ...items, value: newDate };
    });
    this.setState({ dateComponent: newInputDate })
  }
  validationFunction = (dateComponent: any) => {
    return dateComponent.map((d:any) => d.value !== '')
  }
  handleAddDates = async () => {
    let newDateComponent = [...this.state.dateComponent, { value: '' , new : true}]
    this.setState({
      dateComponent: newDateComponent,
    })
  }

  handleRemoveDates = (index: number) => async () => {
    this.setState({
      dateComponent: this.state.dateComponent.filter((section: any, sindex: number) => index !== sindex),
    });
  }
  //#endregion
  deleteIcon(index: number) {
    return (
      <Icon
        style={{ color: 'red', marginLeft: '20px', cursor: "pointer" }}
        type="close"
        onClick={this.handleRemoveDates(index)}
      />
    )
  }

  disabledDate(current: any) {
    if (this.props.UseTodayMin && this.props.UseTodayMax) {
      return current < moment().startOf('day') || current > moment().endOf('day');
    }
    else if (!this.props.UseTodayMin && this.props.UseTodayMax) {
      return (current < moment(this.props.dateMin).startOf('day')) || (current > moment().endOf('day'))
    }
    else if (this.props.UseTodayMin && !this.props.UseTodayMax) {
      return current < moment().startOf('day') || current > moment(this.props.dateMax);
    }
    else if (!this.props.UseTodayMin && !this.props.UseTodayMax) {
      return current < moment(this.props.dateMin).startOf('day') || current > moment(this.props.dateMax).endOf('day')
    }
    else return current;
  }

  getDefaultValue(fieldIndex: number) {
    const { defaultValue } = this.props;
    const { dateComponent } = this.state;
    if (defaultValue) {
      if (defaultValue[fieldIndex]) {
        if(dateComponent[fieldIndex].new) return ''
        return moment(defaultValue[fieldIndex]);
      }
    }
    return undefined;
  }

  render() {
    return (
      <AppContext.Consumer>
        {({ locale }) => (
          <Wrapper>
            <Form>
              <p>{this.props.description}</p>
              <FormItem>
                {this.state.dateComponent.map((items: any, index: number) => (
                  <div key={index}>
                    <FieldsValidation
                      type={TypesValidation.DATE}
                      disabled={this.disabledDate}
                      messageValidation={I18n.l("common.fieldRequired")}
                      handleOnChange={this.handleDateChange(index)}
                      validation={this.props.required ? this.state.valid[index] : true}
                      localeDate={(locale === "pt-BR") ? pt_BR.DatePicker : undefined}
                      innerItems={this.props.repeat && this.props.minRepeat < this.state.dateComponent.length ? this.deleteIcon(index) : <span />}
                      defaultValue={this.getDefaultValue(index)}
                      hour={this.props.hour ? { format: 'HH:mm:ss' } : this.props.hour}
                    // onBlur={this.onBlurDate(index)}
                    />
                  </div>
                ))}
              </FormItem>
              {(this.props.repeat && this.props.maxRepeat > this.state.dateComponent.length) &&
                < Button
                  onClick={this.handleAddDates}
                  style={{ marginLeft: '-15px', fontWeight: 'bold' }}
                  className="goepik-btn-border-main-withoutbold"
                >
                  <Icon type="plus" /> {I18n.l("common.addNew")}
                </Button>
              }
            </Form>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    margin-bottom: 8px;
  }
`
